
import SearchZoomOut from "../../../assets/filled/SearchZoomOut.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SearchZoomOutIcon({ className, dataTestid = "SearchZoomOutIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SearchZoomOut data-testid={dataTestid} className={classes} {...rest} />
  );
}
